<template>
    <div>
        <h3>宣伝する</h3>
        <div>
            <p>
                本棚、及び小説の宣伝は、作者様によって行われるものとして、
                貸し本棚はポータルのみを提供しています。
                ポータルからの流入のみを期待してご登録されると、アクセス数はなかなか伸びません。
            </p>
            <p>
                実際はSNSコミュニティ、小説サーチサービスなどを通じて作品を宣伝することになります。
            </p>
            <h4>SNSで宣伝する</h4>
            <p>
                SNSで作品を宣伝する場合、作品のトップページ（短編の場合は本文ページ）のURLを投稿してください。
                作品の小説カードが投稿に表示されます。
            </p>
            <h4>小説サーチサービスへ登録する</h4>
            <p>
                伝統的なサーチサービスの中で、貸し本棚の登録が認められているのは以下の２サービスです。
            </p>
            <ul>
                <li>
                    <a href="https://r-nomad.com/" target="_blank">恋愛遊牧民Ｒ+ 様</a>
                </li>
                <li>
                    <a href="https://compslink.jp/" target="_blank">COMPASS LINK 様</a>
                </li>
            </ul>
            <p>
                貸し本棚は独自のサブドメインを取得でき、独立サイトに作者様の作品をまとめる構造上、
                こういったサーチサービスへの登録が可能です。
            </p>
            <h5>サーチサービスの種類</h5>
            <p>
                個人サイト、小説関連のサーチサービスは以下の二タイプがあります。
            </p>
            <ul>
                <li>サイト登録型</li>
                <li>作品登録型</li>
            </ul>
            <p>
                サイト登録型の場合は、本棚トップページと本棚名で登録を行います。
                作品に更新があったら、更新情報を追加していきます。
            </p>
            <p>
                作品登録型の場合は、小説目次ページ（短編は本文ページ）と作品名で登録を行います。
                作品別に登録作業を行ってください。
            </p>
            <h5>サーチサービス登録時の注意</h5>
            <p>
                サーチサービスごとの規約に留意してください。
                ほとんどのサーチでは、バックリンクの掲載を義務付けています。
                バックリンクは登録申請前に設置しなければいけません。
            </p>
            <p>
                自己紹介にURLとリンク先名称を記載してください。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "宣伝する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>